export const APP_CONST  = {
    APP_NAME : "TopJob360 - Top job around the world!",
    APP_TOP_LOGO : "https://wolrdjobstorage.blob.core.windows.net/assets/top_logo.png",
    APP_LOGO : "https://wolrdjobstorage.blob.core.windows.net/assets/h_logo.png"
}